import { handleActions } from 'redux-actions';
import reducersUtils from 'state/utils';
import actions from 'state/clientConfig/actionCreators';
import initialState from 'state/clientConfig/initial.state';

const clientConfigReducer = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.setClientConfig]: (state, { payload: { clientConfig } }) => {
      return {
        ...state,
        ...clientConfig,
      };
    },
  },
  initialState
);

export default clientConfigReducer;
